/**
 * @author <Aniket.P>
 * @description MedTransGo constants
 * @copyright Supra International, inc
 */
export class MedTransGoConstants {

    public static readonly FIELD_NAME_TOKEN = 'id_token';
    public static readonly FIELD_STATE = 'state';
    public static readonly FIELD_MEMBER_PROFILE = 'member_profile';

    public static readonly STATUS_SETUP_PENDING = 'SETUP_PENDING';
    public static readonly STATUS_PENDING_VERIFICATION = 'PENDING_VERIFICATION';

    public static readonly FIELD_LANGUAGES = 'serviceType';


    // URLs
    public static readonly URL_SIGNUP = '/register';
    public static readonly VIEW_SIGNUP_NAME = 'SignupPage';

    public static readonly URL_PENDING_VERIFICATION = '/pending-verification';
    public static readonly VIEW_PENDING_VERIFICATION = 'PendingVerification';

    public static readonly URL_REQUESTS = '/requests';
    public static readonly VIEW_REQUESTS_PANEL_NAME = 'RequestPanel';
    public static readonly VIEW_MAIN_LAYOUT_NAME = 'MainLayout';
    public static readonly VIEW_REQUEST_DETAILS_NAME = 'ViewRequestDetail';

    public static readonly URL_USERS = 'users';
    public static readonly VIEW_USERS_NAME = 'Users';

    public static readonly URL_API_INTEGRATION = 'api-integration';
    public static readonly VIEW_API_INTEGRATION_NAME = 'ApiIntegration';

    public static readonly URL_ADD_ACCESS_KEY = 'add';
    public static readonly VIEW_ADD_API_KEY_NAME = 'AddAccessKeyModal';

    public static readonly URL_ACCESS_KEY_LIST = 'access-keys';
    public static readonly VIEW_ACCESS_KEY_LIST_NAME = 'AccessKeyList';

    public static readonly VIEW_CALENDAR_NAME = 'calendar';
    public static readonly URL_CALENDAR = '/calendar';

    public static readonly URL_INVOICE_PANEL = 'invoices';
    public static readonly VIEW_INVOICE_PANEL_NAME = 'Invoices';

    public static readonly URL_INVOICE_RECEIPT = ':id';
    public static readonly VIEW_INVOICE_RECEIPT_NAME = 'ViewReceiptModal';

    public static readonly URL_INVOICE_PAY = 'pay';
    public static readonly VIEW_INVOICE_PAY_NAME = 'ViewInvoicePayModal';

    public static readonly URL_ADD = 'patients/add';
    public static readonly VIEW_ADD_PATIENT_NAME = 'AddPatientForm';

    public static readonly URL_UPDATE = 'patients/update/:id';
    public static readonly VIEW_UPDATE_PATIENT_NAME = 'UpdatePatientForm';

    public static readonly URL_VIEW = 'patients/view';
    public static readonly VIEW_VIEW_PATIENT_NAME = 'ViewPatientForm';

    public static readonly URL_SETTING = '/settings';
    public static readonly VIEW_SETTING_NAME = 'Setting';

    public static readonly URL_RIDE_CREDIT_MANAGEMENT = 'rideCredit';
    public static readonly VIEW_RIDE_CREDIT_MANAGEMENT = 'RideCreditManagement';

    public static readonly URL_REPORTS = '/reports';
    public static readonly VIEW_REPORTS_NAME = 'Reports';

    public static readonly VIEW_DASHBOARD_NAME = 'dashboard';
    public static readonly URL_DASHBOARD = '/dashboard';

    public static readonly URL_ADD_MEMBER = 'members/add';
    public static readonly VIEW_ADD_MEMBER_NAME = 'AddMemberModal';

    public static readonly URL_UPDATE_MEMBER = 'members/update';
    public static readonly VIEW_UPDATE_MEMBER_NAME = 'UpdateMemberModal';

    public static readonly URL_ADD_HEALTHCARE_PROVIDER = 'healthcareprovider/add';
    public static readonly VIEW_ADD_HEALTHCARE_PROVIDER_NAME = 'AddHealthCareProviderModal';

    public static readonly URL_UPDATE_HEALTHCARE_PROVIDER = 'healthcareprovider/update';
    public static readonly VIEW_UPDATE_HEALTHCARE_PROVIDER_NAME = 'UpdateHealthCareProviderModal';

    public static readonly URL_UPDATE_RX_PROVIDER = 'rxprovider/update';
    public static readonly VIEW_UPDATE_RX_PROVIDER_NAME = 'UpdateRxProviderModal';

    public static readonly URL_ADD_LOCATION = 'locations/add';
    public static readonly VIEW_ADD_LOCATION_NAME = 'AddLocationModal';

    public static readonly URL_UPDATE_LOCATION = 'locations/update';
    public static readonly VIEW_UPDATE_LOCATION_NAME = 'UpdateLocationModal';

    public static readonly URL_VIEW_REQUEST_DETAILS_MODAL = '';
    public static readonly VIEW_REQUEST_DETAILS_MODAL_NAME = 'ViewRequestDetailModal';

    public static readonly URL_REQUESTS_TABLE = '/service-requests';
    public static readonly VIEW_REQUESTS_TABLE_NAME = 'Requests';

    public static readonly URL_ACCOUNT_SETUP = '/account-setup';
    public static readonly VIEW_ACCOUNT_SETUP_NAME = 'AccountSetup';

    public static readonly URL_MEMBER_TYPE = 'member-type';
    public static readonly VIEW_MEMBER_TYPE_NAME = 'MemberType';

    public static readonly URL_ORGANIZATION = 'organization';
    public static readonly VIEW_ORGANIZATION_NAME = 'SelectOrganization';

    public static readonly URL_SUBSCRIPTION_PLANS = 'subscription-plans';
    public static readonly VIEW_SUBSCRIPTION_PLANS_NAME = 'SubscriptionPlans';

    public static readonly URL_SUBSCRIPTION_PLAN = '/subscription-plan';
    public static readonly VIEW_SUBSCRIPTION_PLAN_NAME = 'SubscriptionPlan';

    public static readonly URL_PAYMENT_INFORMATION = 'payment-information';
    public static readonly VIEW_PAYMENT_INFORMATION_NAME = 'paymentInformation';

    public static readonly URL_NEW_SERVICE_REQUEST = 'new-service-request';
    public static readonly VIEW_NEW_SERVICE_REQUEST = 'NewServiceRequest';

    public static readonly URL_RESCHEDULE_REQUEST = 'reschedule';
    public static readonly VIEW_RESCHEDULE_REQUEST = 'RescheduleRequest';

    public static readonly URL_EDITSERVICEDETAILS_REQUEST = 'update';
    public static readonly VIEW_EDITSERVICEDETAILS_REQUEST = 'EditServiceRequestDetails';

    public static readonly URL_APPROVE_AUCTION_REQUEST = 'approve';
    public static readonly VIEW_APPROVE_AUCTION_REQUEST = 'ArpproveAuctionRequest';

    public static readonly URL_SERVICE_REQUEST_SERVICE_VISIT = 'service-visit';
    public static readonly VIEW_SERVICE_REQUEST_SERVICE_VISIT = 'ServiceVisit';

    public static readonly URL_SERVICE_REQUEST_VEHICLE_LANGUAGE = 'vehicle-language';
    public static readonly VIEW_SERVICE_REQUEST_VEHICLE_LANGUAGE = 'VehicleLanguage';

    public static readonly URL_SERVICE_REQUEST_MEETING_DETAILS = 'meeting-details';
    public static readonly VIEW_SERVICE_REQUEST_MEETING_DETAILS = 'MeetingDetails';

    public static readonly URL_SERVICE_REQUEST_ADDRESS_BILLING = 'address-billing';
    public static readonly VIEW_SERVICE_REQUEST_ADDRESS_BILLING = 'AddressBilling';

    public static readonly URL_SERVICE_REQUEST_PICKUP_DETAILS = 'pickup-details';
    public static readonly VIEW_SERVICE_REQUEST_PICKUP_DETAILS = 'PickupDetails';

    public static readonly URL_SERVICE_REQUEST_HOME_HEALTHCARE_DETAILS = 'healthcare-service-details';
    public static readonly VIEW_SERVICE_REQUEST_HOME_HEALTHCARE_DETAILS = 'HealthCareServiceDetails';

    public static readonly URL_SERVICE_REQUEST_CONFIRMATION = 'confirmation';
    public static readonly VIEW_SERVICE_REQUEST_CONFIRMATION = 'Confirmation';

    public static readonly URL_RIDE_LIVE_LOCATION = '/track';
    public static readonly VIEW_RIDE_LIVE_LOCATION = 'RideLiveLocation';

    public static readonly URL_PATIENT_PAY = '/pay';
    public static readonly VIEW_PATIENT_PAY = 'PatientPaymentModal';

    public static readonly URL_UNAUTHORIZED = '/unauthorized-access';
    public static readonly URL_UNAUTHORIZED_PAGE = 'unauthorizedAccess';

    public static readonly URL_ADD_ATTORNEY = 'attorneys/add';
    public static readonly VIEW_ADD_ATTORNEY_NAME = 'AddAttorneysForm';

    public static readonly URL_UPDATE_ATTORNEY = 'attorneys/update/:id';
    public static readonly VIEW_UPDATE_ATTORNEY_NAME = 'UpdateAttorneyForm';

    public static readonly URL_VIEW_ATTORNEY = 'attorneys/view';
    public static readonly VIEW_VIEW_ATTORNEY = 'ViewAttorneyForm';
    public static readonly URL_VIEW_ORDER = 'orders/:id';
    public static readonly VIEW_VIEW_ORDER = 'ViewOrder';
    public static readonly URL_SUBMIT_DRAFT_TRANSPORT_REQUEST = '/draft/:id/transport';
    public static readonly VIEW_SUBMIT_DRAFT_TRANSPORT_REQUEST = 'SubmitDraftTransportRequest';
    public static readonly URL_UPLOAD_BATCH_REQUEST_VIA_EXCEL = 'upload-request';
    public static readonly VIEW_UPLOAD_BATCH_REQUEST_VIA_EXCEL = 'UploadBatchRequest';

    // HTTP URL
    public static readonly HTTP_URL_LOGIN = '/v1/authentication';
    public static readonly HTTP_URL_USER_REGISTRATION = '/v1/register';
    public static readonly HTTP_URL_GET_USERS = '/v1/users';
    public static readonly HTTP_URL_PAYMENT = '/v1/payment';
    public static readonly HTTP_URL_ROUTES = '/v1/routes';
    public static readonly HTTP_URL_MEMBERS = '/v1/members';
    public static readonly HTTP_URL_PROVIDERS = '/v1/healthcareproviders';
    public static readonly HTTP_URL_RXPROVIDERS = '/v1/rxproviders';
    public static readonly HTTP_URL_USERS = '/v1/users';
    public static readonly HTTP_URL_PATIENTS = '/v1/patients';
    public static readonly HTTP_URL_INVOICE = '/v1/invoices';
    public static readonly HTTP_URL_ORGANIZATIONS = '/v1/organizations';
    public static readonly HTTP_URL_CHANGE_PASSWORD = '/v1/changePassword';
    public static readonly HTTP_URL_ADD_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/source`;
    public static readonly HTTP_URL_REQUEST = '/v1/requests';
    public static readonly HTTP_URL_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/source`;
    public static readonly HTTP_URL_ADD_PATIENT = `${MedTransGoConstants.HTTP_URL_PATIENTS}`;
    public static readonly HTTP_URL_DEFAULT_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/defaultSource`;
    public static readonly HTTP_URL_VERIFY_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/verifyPaymentSource`;
    public static readonly HTTP_URL_LANGUAGES = '/v1/languages';
    public static readonly HTTP_URL_RESOURCE = '/v1/resources';
    public static readonly HTTP_URL_INVOICES = '/v1/invoices';
    public static readonly HTTP_URL_SUBSCRIPTIONS = '/v1/subscriptions';
    public static readonly HTTP_URL_ACCESS_KEYS = '/v1/accessKeys';
    public static readonly HTTP_URL_TRANSPORTERS = '/v1/transporters';
    public static readonly HTTP_URL_INTERPRETERS = '/v1/interpreters';
    public static readonly HTTP_URL_PARTNERS = '/v1/partners';
    public static readonly HTTP_URL_FEEDBACKS = '/v1/feedbacks';
    public static readonly HTTP_URL_ATTORNEY = '/v1/attorneys';
    public static readonly HTTP_URL_REQUESTS_V2 = '/v2/requests';




    // Events
    public static readonly EVENT_SHOW_TOAST = 'show_toast';
    public static readonly EVENT_LOGOUT = 'logout';
    public static readonly EVENT_SAVE_MEMBER_REQUEST = 'save_member_request';
    public static readonly EVENT_CHANGE = 'change';
    public static readonly EVENT_SHOW_LOADER = 'show_loader';
    public static readonly EVENT_CONFIRMATION_DIALOG = 'confirmationDialog';
    public static readonly EVENT_PAGE_CHANGE = 'pageChange';

    // Error Code
    public static readonly ERROR_CODE_NETWORK_ERROR = 'NETWORK_ERROR';
    public static readonly ERROR_CODE_ROUTE_NOT_FOUND = 'ROUTE_NOT_FOUND';

    public static readonly PAGINATION_LIMIT = 10;
    public static readonly DB_QUERY_MAX_RESULT = 1000;

    // Regular Expression Constants
    public static readonly PHONE_REGX = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    public static readonly PASSWORD_REGX = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).*$/;

}
